<template>
  <div class="hotkey-container">
    <hotkey-group v-for="group in source.groups" :key="group.name" :group="group"/>
  </div>
</template>

<script>
  import HotkeyGroup from '@/components/HotkeyGroup.vue'
  import Masonry from 'masonry-layout'

  export default {
    name: 'HotkeyPage',
    components: {
      HotkeyGroup
    },
    props: ['source', 'name'],
    data() {
      return {
        masonry: null
      }
    },
    methods: {
      initMasonry() {
        this.masonry = new Masonry('.hotkey-container', {
          itemSelector: '.group-container',
          columnWidth: 450,
          gutter: 20,
          fitWidth: true,
          transitionDuration: 0
        })
      },
      refreshMasonry() {
        this.masonry.reloadItems();
        this.masonry.layout();
      }
    },
    mounted() {
      this.$store.commit('setActiveApp', this.name);
      this.$store.commit('loadHotkeys', this.source);

      if (this.masonry === null) {
        this.initMasonry();
      }

      this.refreshMasonry();
    },
    updated() {
      this.refreshMasonry();
    }
  }

</script>
<style>
  .hotkey-container {
    margin: auto;
  }
</style>